import React from "react";
import { Modal, ModalBody, Button } from "@/Components/Common/Tailwind";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoginPromptModal = ({ isOpen, onClose }: LoginPromptModalProps) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate("/login");
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="sm">
      <ModalBody className="text-center p-8">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
          <LogIn size={32} className="text-gray-600" />
        </div>
        <h3 className="text-lg font-bold mb-2" style={{ fontFamily: "Gmarket-B" }}>
          로그인이 필요합니다
        </h3>
        <p className="text-gray-500 text-sm mb-6">
          주문하려면 먼저 로그인해 주세요.
        </p>
        <div className="flex flex-col gap-2">
          <Button
            onClick={handleLogin}
            variant="primary"
          >
            로그인하기
          </Button>
          <Button
            onClick={onClose}
            variant="secondary"
          >
            취소
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LoginPromptModal;
